<template>
    <admin-dashboard-layout>
        <v-data-table
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="prohibited_words"
            :items-per-page="30"
            class="elevation-1"
            @click:row="handleClickRow"
        >
            <template v-slot:item.created_at="{ item }">
                {{ item.created_at ? moment(item.created_at).format('LLL') : '' }}
            </template>
        </v-data-table>
    </admin-dashboard-layout>
</template>

<script>
    import AdminDashboardLayout from "../../../layouts/AdminDashboardLayout";
    import ProhibitedWords from "../../../models/ProhibitedWords";
    /* eslint-disable */    export default {
        name: "prohibited-words-index",
        components: {
            AdminDashboardLayout,
        },
        data: function () {
            return {
                loading: false,
                prohibited_words: [],
                headers: [
                    {
                        text: '# ID',
                        align: 'start',
                        sortable: false,
                        value: 'id',
                    },
                    { text: 'Word', value: 'word' },
                    { text: 'Active', value: 'is_active' },
                    { text: 'Created at', value: 'created_at' },
                ],
            }
        },
        methods: {
            handleClickRow(word) {
                this.$router.push({name: 'admin.prohibited_words.show', params: {id: word.id}})
            }
        },
        async mounted() {
            this.loading = true
            this.prohibited_words = await ProhibitedWords.get()
            this.loading = false
        },
    }
</script>

<style scoped>

</style>
